import styled from 'styled-components';
import { Button } from 'antd';

export const CreateButton = styled(Button)`
	display: flex;
	align-items: center;
	font-size: 0.9375rem;
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	background: ${({ theme }) => theme.palette.primary.default};

	span:first-child {
		margin-top: 0.1875rem;
		font-size: 1.25rem;
	}
`;
